import React from "react";
import "./index.less";
import { useLocation } from "react-router-dom";
import UserInfoComponent from "@/components/UserInfoComponent";
import { Button, Form, Input, message } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { request } from "@/utils/request"

export default function Feedback() {
    const [form] = Form.useForm();
    const onFinish = values => {
        console.log('Success:', values);
        request.post('consult/create', {
            mobile: values.mobile,
            name: values.name,
            content: values.content
        }).then(r => {
            if(r.code){
                message.error(r.msg)
                return;
            }
            message.success('提交成功')
            setTimeout(() => {
                form.resetFields();
            }, 500)
        })
    };
    return (
        <>
            <div className="feedback-background">
                <div className="feedback-content">
                    <div className="feedback-title">意见反馈</div>
                    <div className="feedback-form">
                        <Form
                            form={form}
                            name="basic"
                            labelCol={{ span: 8 }}
                            style={{ maxWidth: 600, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                            initialValues={{ 
                                name:null,mobile:null,content:null
                             }}
                            layout="vertical"
                            onFinish={onFinish}
                            // onFinishFailed={onFinishFailed}
                            autoComplete="off"
                        >
                            <Form.Item
                                style={{ fontWeight: 'bold', width: '100%' }}
                                label="姓名"
                                name="name"
                                rules={[{ required: true, message: '请输入姓名' }]}
                            >
                                <Input placeholder="请输入姓名" maxLength={50}/>
                            </Form.Item>

                            <Form.Item
                                style={{ fontWeight: 'bold', width: '100%' }}
                                label="微信号"
                                name="mobile"
                                rules={[{ required: true, message: '请输入微信号' }]}
                            >
                                <Input placeholder="请输入微信号"  maxLength={50}/>
                            </Form.Item>
                            <Form.Item
                                style={{ fontWeight: 'bold', width: '100%' }}
                                label="留言"
                                name="content"
                            >
                                <TextArea placeholder="请输入留言"  maxLength={100}/>
                            </Form.Item>

                            <Form.Item label={null}>
                                <Button type="primary" htmlType="submit" style={{ width: '120px', height: '40px', marginTop: '40px' }}>
                                    确定
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );

}

